import { FieldValidatorType } from "@progress/kendo-react-form";


export const minVal60Validator: FieldValidatorType = (value: string) => {
    return parseInt(value) >= 60 ? "" : "La durata non può essere inferiore a 60";
}

